export const CANCELLATION_REASON_VENDOR_NO_QUOTE =
  'Vendor did not provide quote during expected time window';

export const CANCELLATION_REASON_ALL_QUOTES_EXPIRED = 'ALL_QUOTES_EXPIRED';

export const CANCELLATION_REASON_DISPLAY_MAP: Readonly<Record<string, string>> =
  {
    [CANCELLATION_REASON_VENDOR_NO_QUOTE]:
      'Vendors did not provide quote during expected time window',
    [CANCELLATION_REASON_ALL_QUOTES_EXPIRED]: 'All vendor quotes expired.',
  };

export type CancellationScope = 'ENTIRE_JOB' | 'SPECIFIC_FILES';

export interface CancelScopeDialogResult {
  scope: CancellationScope;
}

export interface CancelReasonDialogData {
  jobUid: string;
  maxLength: number;
}

export interface CancelReasonDialogResult {
  confirmed: boolean;
  reason?: string;
}

export interface CancelFlowState {
  scope: CancellationScope | null;
  reason: string;
  isSubmitting: boolean;
}
